import React, { useEffect, useState } from "react";
import "./expand.css";
import minimize from "../../assets/minimize.png";
import maximize from "../../assets/maximize.png";
const ExpandIcon = ({ fullScreen, setExpand, bottom }) => {
  const [iPhone, setIPhone] = useState(false);

  useEffect(() => {
    let os = navigator.userAgent;
    if (os.search("iPhone") !== -1) {
      setIPhone(true);
    } else {
      setIPhone(false);
    }
  }, []);

  return (
    <>
      {!iPhone && (
        <img
          src={fullScreen ? minimize : maximize}
          className={fullScreen ? "minimize" : "maximize"}
          style={{ bottom: bottom && "0" }}
          onClick={() => {
            setExpand(fullScreen ? false : true);
          }}
        />
      )}
    </>
  );
};

export default ExpandIcon;
